import getBooleanFromString from 'www/utils/get/getBooleanFromString'

/**
 * @description
 *
 * Трансформирует поля переданного объекта в 'Boolean' значение
 *
 * @param {object} object - объект, в котором необходимо произвести трансформацию
 * @param { Array<string> } propList - список ключей
 */

function transformPropsToBoolean(object = {}, propList = []) {
  propList.forEach(prop => {
    if (object[prop]) {
      object[prop] = getBooleanFromString(object[prop])
    }
  })
}

export default transformPropsToBoolean
